var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForwardTrack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.199,
    height: 59.213,
    viewBox: "0 0 53.199 59.213",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_28",
    "data-name": "Union 28",
    d: "M7.793,7.789A26.421,26.421,0,0,0,0,26.6H3.311A23.289,23.289,0,0,1,43.066,10.13,23.291,23.291,0,0,1,26.85,49.887V43.381L14.407,51.3,26.85,59.213V53.195A26.6,26.6,0,0,0,45.408,7.789a26.6,26.6,0,0,0-37.616,0Z",
    transform: "translate(53.199 59.213) rotate(180)",
    fill: "#161615"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardTrack);
export default __webpack_public_path__ + "static/media/forwardTrack.0708ab2888c3924ef0ec8483fab3e22e.svg";
export { ForwardRef as ReactComponent };